/** Add an identifier only when distinct choices have the same visible name. */
export function disambiguateOptionLabels<T extends { label: string; value: string }>(options: readonly T[]): T[] {
  const valuesByLabel = new Map<string, Set<string>>();
  const normalize = (label: string) => label.trim().toLowerCase();
  for (const option of options) {
    const label = normalize(option.label);
    const values = valuesByLabel.get(label) ?? new Set<string>();
    values.add(option.value);
    valuesByLabel.set(label, values);
  }
  return options.map(option =>
    option.value && (valuesByLabel.get(normalize(option.label))?.size ?? 0) > 1
      ? { ...option, label: `${option.label} (${option.value})` }
      : option,
  );
}
